import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {
    AnyImageOpContext,
    AnyImageOpResult,
    ImageOpOutputs,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/blend-border/definition"
import {ImageOpNodeBlendByLaplacianPyramid} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/blend-by-laplacian-pyramid/node"
import {ImageOpNodeBlend} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/blend/node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"
import {Definition} from "@app/textures/texture-editor/operator-stack/operators/test/node/definition"

@registerNode
export class ImageOpNodeTilingBlendBorder extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeTilingBlendBorder"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof Definition>> {
        const {mask, highBorder, lowBorder, testParam1, testParam2, useLaplacianBlending, debugDrawEnabled} = await evaluator.getAll(this.parameters)
        let blendedBorder: ValueOrNode<AnyImageOpResult>
        if (debugDrawEnabled) {
            blendedBorder = mask
        } else {
            if (useLaplacianBlending) {
                blendedBorder = imageOpNodeBag.getNode("blendByLaplacianPyramid", ImageOpNodeBlendByLaplacianPyramid, {
                    backgroundImage: highBorder,
                    foregroundImage: lowBorder,
                    maskImage: mask,
                    testParam1: testParam1,
                    testParam2: testParam2,
                })
            } else {
                blendedBorder = imageOpNodeBag.getNode("blend", ImageOpNodeBlend, {
                    backgroundImage: highBorder,
                    foregroundImage: lowBorder,
                    alpha: mask,
                    premultipliedAlpha: false,
                    blendMode: "over",
                })
            }
        }
        return await evaluator.get(blendedBorder)
    }
}
